import Container from "../../../components/element/container";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import OrderDocumentsModal from "../../../components/modal/order.documents.modal";
import { getOrderDocuments } from "../../../helpers/order.documents";
import { DcLogo } from "../../../assets/images";
import Icon from "../../../components/element/icon";
import Image from "../../../components/element/image";
import formatNumber from "../../../helpers/format.number";
import Col from "../../../components/element/col";
import useWindowDimension from "../../../components/hook/use.window.dimension";

// A listing only has car information worth opening once it has reached the
// showroom, so the link stays hidden on the earlier stages.
const CAR_INFO_STATUSES = ["preparing-go-live", "live", "sold"];

export default function ConsignRecord({ consign, onPay }) {
  const [documentsOpen, setDocumentsOpen] = useState(false);
  const { t } = useTranslation();
  const { width } = useWindowDimension();
  const hasDocuments = getOrderDocuments(consign).length > 0;
  const statusClass = consign.status.toLowerCase().replace(/\s+/g, "-");
  const canViewCarInfo = CAR_INFO_STATUSES.includes(
    String(consign.status || "")
      .toLowerCase()
      .replace(/[\s_]+/g, "-"),
  );
  const details = [
    ["Consignment ID", consign.reference_no, "accent"],
    [
      "Total View / Reserve",
      consign.product?.id
        ? `${consign.total_view || "0"} / ${consign.total_reserves || "0"}`
        : "- / -",
    ],
    width > 991 && ["status", consign.status, "status"],
    ["Inspection On", consign.inspection?.inspection_date],
    ["Live On", consign.live_at],
    [
      "Selling Price",
      consign.product?.id ? `RM${formatNumber(consign.product?.price)}` : null,
    ],
    width < 991 && ["status", consign.status, "status"],
  ].filter(Boolean);

  return (
    <>
      <article className={`purchase-record ${statusClass}`}>
        <Container tag="div" className="purchase-record-media">
          <Image
            src={
              consign.car_photo_media?.length > 0
                ? consign.car_photo_media[0]?.url
                : DcLogo
            }
            alt={""}
            className={`_img h-100 ${
              consign.car_photo_media?.length > 0 ? "" : "default"
            }`}
          />
        </Container>
        <Container tag="div" className="purchase-record-content">
          {consign.product?.id && (
            <header
              className={`purchase-record-header ${width < 650 && consign.next_step === "await_inspection_payment" ? "flex-col" : ""}`}
            >
              <h2>{consign.product?.name || ""}</h2>
              <Container tag="div"
                className={`purchase-record-icons ${width < 650 && consign.next_step === "await_inspection_payment" ? "w-100 justify-end" : ""}`}
              >
                {hasDocuments && (
                  <button
                    type="button"
                    className="record-icon-button"
                    aria-label="View vehicle documents"
                    onClick={() => setDocumentsOpen(true)}
                  >
                    <Icon
                      icon="fluent:document-one-page-link-24-regular"
                      className="--doc"
                    />
                  </button>
                )}
                {consign.product?.id && canViewCarInfo && (
                  <Link
                    to={`/car/${consign.product.id}`}
                    className="record-icon-button"
                    aria-label="View car information"
                  >
                    <Icon icon="mdi:car-info" />
                  </Link>
                )}

                {consign.next_step === "await_inspection_payment" &&
                  consign.inspection_order?.id &&
                  consign.inspection_order?.payment_status === "pending" && (
                    <button type="button" onClick={() => onPay(consign)}>
                      <Icon icon="solar:card-linear" />
                      {t("Pay")}
                    </button>
                  )}
              </Container>
            </header>
          )}
          <Col className="_col purchase-divider" />
          <Container tag="div" className="purchase-record-details">
            {details.map(([label, value, variant]) =>
              label === "status" ? (
                <p className={`purchase-status ${statusClass}`} key={label}>
                  {value === "new"
                    ? t("Under Review")
                    : value === "inspection"
                      ? t("Pending Inspection")
                      : t(value)}
                </p>
              ) : (
                <dl className={variant || ""} key={label}>
                  <dt>{t(label)}</dt>
                  <dd>{value || "-"}</dd>
                </dl>
              ),
            )}
          </Container>
        </Container>
      </article>
      {documentsOpen && (
        <OrderDocumentsModal
          order={consign}
          onClose={() => setDocumentsOpen(false)}
        />
      )}
    </>
  );
}
